import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { contact } from 'settings';
import { BackButton } from 'C4';


const ContactView = () => (
  <div className="contentContainer contact">
    <div className="contactView__Header" />
    <div className="contactView">
      <div className="contactView__Content">
        {contact.image && <img src={contact.image} alt={contact.organisation} />}
        <h1>{contact.organisation}</h1>
        {contact.address && <p><FontAwesomeIcon icon={['fas', 'envelope']} />{contact.address}</p>}
        {contact.phone && <p><FontAwesomeIcon icon={['fas', 'phone']} />{contact.phone}</p>}
        {contact.fax && <p><FontAwesomeIcon icon={['fas', 'fax']} />{contact.fax}</p>}
        {contact.email[0] && <a href={`mailto:${contact.email[0]}`}><FontAwesomeIcon icon={['fas', 'envelope']} />{contact.email[0]}</a>}
        {contact.website && <a href={contact.website} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={['fas', 'link']} />{contact.website}</a>}
      </div>
    </div>
  </div>
);

export default ContactView;
